import * as React from "react"
import { graphql } from "gatsby"
import LocalizedLink from "../../../components/LocalizedLink"
import { useTranslation } from "react-i18next"
import ProductList from "../../../components/ProductList"

export const Head = ({ data, pageContext }) => {
    const { t } = useTranslation()
    const { locale } = pageContext
    const { tag } = data

    const needTranslate = locale.slice(0, 2) !== 'zh'
    const languageCode = locale.split("-")[0]
    const i18nTag = tag.i18n.find((p) => p.language === languageCode)

    const tagName = (needTranslate && i18nTag) ? i18nTag.name : tag.name

    return (
        <>
            <html lang={locale} />
            <title>{`${t('products.title')} - ${tagName} - ${t('products.tags')}`} | {t('site.name-abbr')}</title>
            {/* <meta name="description" content="Hello World" /> */}
        </>
    )
}

const ProductsByTag = ({ data, pageContext }) => {
    const { tag, allProduct } = data
    const { t } = useTranslation()
    const { locale } = pageContext

    const needTranslate = locale.slice(0, 2) !== 'zh'
    const languageCode = locale.split("-")[0]
    const i18nTag = tag.i18n.find((p) => p.language === languageCode)

    const tagName = (needTranslate && i18nTag) ? i18nTag.name : tag.name


    return (
        <div>
            <div
                style={{
                    margin: `0 auto`,
                    maxWidth: 1280,
                    padding: `24px 16px 32px 16px`,
                    textAlign: 'left',
                    lineHeight: 2
                }}
            >
                <h1 className="text-4xl mb-4">{t("products.title")} {t('products.tags')}</h1>
                <h2 className="text-2xl mb-4">
                    <LocalizedLink to="/products">{t("products.all")}</LocalizedLink> {'>> '}
                    {t("tags")}:{tagName}
                </h2>
                <ProductList
                    fromView={'tags'}
                    productEdges={allProduct.edges}
                    locale={locale} />
            </div>
        </div>
    )
}

export default ProductsByTag

export const query = graphql`
  query($id: String) {
    allProduct(filter: {tagIds: {in: [$id]}}) {
        edges {
            node {
                id
                productStatus
                departmentCode
                departmentPath
                category
                categoryId
                model
                name
                picture
                tags
                tagIds
                departmentName
                categoryName
                thumbnail
                i18n {
                    language
                    name
                    info
                    categoryName
                    tags
                }
            }
          }
      }
      tag(id: {eq: $id}) {
        id
        name
        i18n {
            language
            name
        }
      }
  }
`